function Pagina () {
  return <div style={{ color: 'white', textAlign: 'center', minHeight: '100vh', justifyContent: 'center', display: 'flex', flexDirection: 'column' }}>
    <h1>Só um minuto...</h1>
    <span>Estamos aguardando a confirmação do pagamento...</span>
  </div>
}

export default Pagina